// Compara franjas horarias con formato "H:MM-H:MM" cronológicamente
// (orden por hora de inicio y luego por hora de fin), en vez de alfabéticamente
// ("10:00-11:00" no debe ir antes que "9:00-10:00").
function minutosDesdeHora(hm) {
  const [h, m] = String(hm || "0:0").trim().split(":").map(Number);
  return (Number.isFinite(h) ? h : 0) * 60 + (Number.isFinite(m) ? m : 0);
}

export function compararFranjas(a, b) {
  const [aIni, aFin] = String(a || "").split("-");
  const [bIni, bFin] = String(b || "").split("-");
  const diffIni = minutosDesdeHora(aIni) - minutosDesdeHora(bIni);
  if (diffIni !== 0) return diffIni;
  return minutosDesdeHora(aFin) - minutosDesdeHora(bFin);
}

export function ordenarFranjas(franjas) {
  return [...(franjas || [])].sort(compararFranjas);
}
